<div class="container">
  <!-- Problems connecting callout — hidden when diagnostic is running or complete -->
  @if (!isRunningDiagnostic() && !isDiagnosticComplete()) {
    <div class="diagnostic-callout">
      <img src="assets/icons/wifi-off.svg" [alt]="('settings.MICROPHONE_ALT' | transloco)" class="callout-icon">
      <span class="callout-text">
        {{ problemsConnectingPrefix }}
        <a class="diagnostic-link" (click)="onRunDiagnosticClick()">{{ clickHereLabel }}</a>
        {{ toRunDiagnosticSuffix }}
      </span>
    </div>
  }

  <!-- Diagnostic Running button — shown in place of callout while running -->
  @if (isRunningDiagnostic()) {
    <button qai-button size="medium" kind="secondary" shape="rectangle" [disabled]="true" class="diagnostic-running-btn">
      <qai-spinner size="small" positionStart></qai-spinner>
      {{'settings.DIAGNOSTIC_RUNNING' | transloco}}
    </button>
  }

  <!-- Rerun button — shown after diagnostic completes -->
  @if (isDiagnosticComplete()) {
    <button qai-button size="medium" kind="tertiary" shape="rectangle" (click)="onRunDiagnosticClick()" class="diagnostic-running-btn">
      {{'settings.RERUN_DIAGNOSTIC' | transloco}}
    </button>
  }

  <!-- Diagnostic running message -->
  @if (isRunningDiagnostic()) {
    <div class="diagnostic-message info-message">
      {{'settings.DIAGNOSTIC_RUNNING_MESSAGE' | transloco}}
    </div>
  }

  <!-- Diagnostic result messages -->
  @if (isDiagnosticComplete() && diagnosticResult() && !diagnosticResult()!.hasPassed) {
    <div class="copy-results-row">
      <button #floatingRef qai-button kind="secondary" size="medium" shape="rectangle" class="copy-results-btn" (click)="onCopyResultsClick()">
        {{'settings.COPY_DIAGNOSTIC_RESULTS' | transloco}}
      </button>
      <qai-tooltip
        [qaiFloating]="floatingRef.elementRef.nativeElement" [placement]="'below-center'" [events]="['click']"
        [style.maxWidth]="'300px'">
        {{'settings.DIAGNOSTIC_RESULTS_COPIED' | transloco}}
      </qai-tooltip>
    </div>

    <div class="diagnostic-message error-message">
      <img src="assets/icons/alert-circle.svg" [alt]="('settings.ALERT' | transloco)" class="message-icon">
      {{'settings.DIAGNOSTIC_FAILED_MESSAGE' | transloco}}
    </div>
  }

  @if (isDiagnosticComplete() && diagnosticResult()?.hasPassed) {
    <div class="diagnostic-message success-message">
      {{'settings.DIAGNOSTIC_PASSED' | transloco}}
    </div>
  }
</div>